module.exports = __webpack_public_path__ + "media/images/weather/114_day-65faa91cdaee0b8d25da51d674b96c76.png";